import { Actor, Engine, ImageSource, vec, Vector } from 'excalibur';
import { makeBlurMaterial } from '../../../../shared/utilities/makeBlurMaterial';

export class InfiniteLayer extends Actor {
    private _sprite: any;
    private _speed: number;
    private _twin: Actor;
    private _screenWidth: number;

    constructor({ image, speed, zIndex, screenWidth, screenHeight, position = vec(0, 0), anchor = vec(0, 0), blur }: {
        image: ImageSource, speed: number, zIndex: number, screenWidth: number, screenHeight: number, position?: Vector, anchor?: Vector, blur?: ReturnType<typeof makeBlurMaterial>
    }) {
        super({ pos: position, anchor });

        this._speed = speed;
        this.z = zIndex;
        this._screenWidth = screenWidth;

        // 1. Prepare the Sprite
        this._sprite = image.toSprite();

        // FORCE SCALE: Tell the sprite to draw at the exact size of the screen
        this._sprite.destSize = {
            width: screenWidth,
            height: screenHeight
        };

        // 2. Setup This Actor
        this.graphics.use(this._sprite);

        // 3. Setup the "Twin" Actor
        // It starts exactly 1 screen-width to the right
        this._twin = new Actor({
            pos: vec(this._screenWidth, position.y),
            anchor,
            z: zIndex
        });
        this._twin.graphics.use(this._sprite);

        if (blur) {
            this.graphics.material = blur;
            this._twin.graphics.material = blur;
        }
    }

    onInitialize(engine: Engine) {
        this.scene?.add(this._twin);
    }

    onPostUpdate(engine: Engine, delta: number) {
        if (this._speed === 0) return;

        // Move Left
        const distance = this._speed * (delta / 1000);
        this.pos.x -= distance;
        this._twin.pos.x -= distance;

        // Reset logic:
        // Because we forced the width to match the screen width, 
        // we can safely reset exactly when x < -screenWidth
        if (this.pos.x <= -this._screenWidth) {
            this.pos.x = this._twin.pos.x + this._screenWidth;
        }

        if (this._twin.pos.x <= -this._screenWidth) {
            this._twin.pos.x = this.pos.x + this._screenWidth;
        }
    }
}
